<template>
	<div class="absolute inset-0 z-50 flex items-center justify-center bg-white">
		<LoadingSVG />
		<span class="sr-only">{{ t('general.loading') }}</span>
	</div>
</template>

<script setup lang="ts">
import LoadingSVG from '@/components/common/LoadingSVG.vue'
import { usePresentationLocale } from '@/i18n'

const { t } = usePresentationLocale()
</script>
